<div class="grid-tiles" *ngIf="dataItems">
	<div class="inner  clearfix">
		<div class="one-second-cell cell "  *ngFor="let item of dataItems">
			<tile-item [dataItem]="item" [imageType]="'block3x1'"  [srcUrl]="srcUrl ? srcUrl : '/work'"></tile-item>
		</div>
	</div>
</div>
